import React from "react";

import { useTranslation } from "react-i18next";

import { SharedLoaderSpinner } from "@components/loader/shared";
import { DeviceDetector } from "@utils";
import classNames from "classnames";
import { observer } from "mobx-react";

interface LoaderSpinnerProps {
	isCountdown?: Countdown;
	contained?: boolean;
	isMobile?: boolean;
	isLoading?: boolean;
	className?: string;
}

type Countdown = {
	countdownValue: number;
	isDesktop?: boolean;
};

export default observer(function LoaderSpinner(props: LoaderSpinnerProps) {
	if (!props.isLoading) {
		return null;
	}

	if (
		props.isCountdown != undefined &&
		props.isCountdown.countdownValue !== 0
	) {
		return (
			<LoaderCountdown
				counter={props.isCountdown?.countdownValue}
				isDesktop={props.isCountdown?.isDesktop}
			/>
		);
	}

	if (props.contained) {
		return <LoaderContained className={props.className} />;
	}

	if (DeviceDetector.isMobileTheme) {
		return <LoaderMobile className={props.className} />;
	}

	return <LoaderFull />;
});

function LoaderCountdown(props: { counter?: number; isDesktop?: boolean }) {
	const { t } = useTranslation();

	return props.isDesktop ? (
		<div className="loader loader--countdown is-sticky">
			<div className="loader--countdown__inner">
				<div className="loader--countdown__box">{props.counter}</div>
				<div className="loader--countdown__title">
					{t<string>("HOME.LOADING")}...
				</div>
			</div>
		</div>
	) : (
		<div className="loader loader--full loader--centered">
			<div className="loader--centered__countdown">{props.counter}</div>
		</div>
	);
}

function LoaderFull() {
	return (
		<div id="loader" className="loader--full">
			<div className="loader--countdown" style={{ display: "none" }}>
				<div className="loader--countdown__box" />
			</div>
			<div className="loader__spinner" />
		</div>
	);
}

function LoaderContained(props: { className?: string }) {
	const { t } = useTranslation();

	return (
		<div
			className={classNames(props.className, "loader", {
				"loader--countdown is-sticky": !props.className,
			})}
		>
			<div
				className={classNames({
					[`${props.className}__spinner`]: props.className,
					"loader--countdown__inner": !props.className,
				})}
			>
				<div className="loader__spinner u-mar--y--reset" />
				<div className="loader__title u-color--core--snow">
					{t<string>("HOME.LOADING")}...
				</div>
			</div>
		</div>
	);
}

function LoaderMobile(props: { className?: string }) {
	return (
		<div
			className={
				"loader " + (props.className ? props.className : "loader--full")
			}
		>
			<SharedLoaderSpinner />
		</div>
	);
}
